import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { fontFaces } from '../fonts';

export const GlobalStyle = createGlobalStyle`
  ${fontFaces}

   .grecaptcha-badge {
    right: unset !important;
    left: 0 !important;
    width: 64px !important;
  }

  * {
    box-sizing: border-box;
    line-height: normal;
  }

  ${normalize}

  #container{
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  button {
    cursor: pointer;
  }

  p {
    color: #333333;
  }

  strong {
    font-weight: 700;
  }
  
  .Toastify__toast--error {
    background-color: #D10000 !important;
  }

  .Toastify__toast--warning {
    background-color: #bd5b00 !important;
  }

  .Toastify__toast--info {
    background-color: #005CDE !important;
  }

  .Toastify__toast--success {
    background-color: #008A00 !important;
  }
`;
